import React from 'react';
import '../../css/common/ImagePreviewOverlay.css';
import useHistoryDismiss from '../../hooks/common/useHistoryDismiss';

const noop = () => {};

/**
 * 画像の全画面ライトプレビュー。
 *
 * 拡大表示中に「写真以外（背景）」をクリックすると閉じる。写真自身のクリックでは
 * 閉じない（stopPropagation）。ズーム/パン/ダウンロード等は持たない軽量版。
 * チャットのプロフィールモーダルと管理者アーティスト詳細ページで共用する。
 *
 * props:
 *   src: string       表示する画像URL。空/falsy のとき何も描画しない。
 *   alt?: string      代替テキスト。
 *   onClose: () => void  背景クリックで呼ばれる。
 */
export default function ImagePreviewOverlay({ src, alt = '画像', onClose = noop }) {
  // ブラウザの戻る/戻るジェスチャーで閉じる。
  useHistoryDismiss(Boolean(src), onClose);
  if (!src) return null;
  return (
    <div
      className="image-preview-overlay"
      role="presentation"
      onClick={(e) => {
        e.stopPropagation();
        onClose();
      }}
    >
      <div className="image-preview-overlay__backdrop" />
      <img
        src={src}
        alt={alt}
        className="image-preview-overlay__img"
        onClick={(e) => e.stopPropagation()}
      />
    </div>
  );
}
